  /* One listener for every accordion on the page, built or server-rendered. */
  (function accordions(){
    var root = document.querySelector(".spw-pdp") || document;
    root.addEventListener("click", function(e){
      var btn = e.target.closest && e.target.closest(".acc-btn");
      if(!btn || !root.contains(btn)) return;
      var pan = btn.nextElementSibling;
      if(!pan || pan.className.indexOf("acc-panel") === -1) return;
      var open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", open ? "false" : "true");
      pan.hidden = open;
    });
  })();
/* Collected before anything else runs so the self-check can report a script
   that died on line one. */
window.__pdpErrors = [];
window.addEventListener("error", function(e){ window.__pdpErrors.push(e.message); });
window.addEventListener("unhandledrejection", function(e){
  window.__pdpErrors.push("promise: " + (e.reason && e.reason.message || e.reason));
});
(function(){
  "use strict";

  /* ---------- formula-driven state ----------
     Every formula lives in FORMULAS, declared just above this script. CUR names
     the one on screen and F is the shortcut. Everything below reads from F, so
     switching formulas is a matter of re-running the builders. */
  var LB_G = 453.592;
  /* The section renders this block from Liquid. Same shape data.py emits,
     so everything below is unchanged from the prototype. */
  var DATA = JSON.parse(document.getElementById("spw-pdp-data").textContent);
  var FORMULAS = DATA.formulas, IMG = DATA.img, ORDER = DATA.order;
  var CUR = DATA.current;
  var _rangeEl = document.getElementById("spw-pdp-range");
  var RANGE = _rangeEl ? JSON.parse(_rangeEl.textContent) : {n:0,avg:0,hist:[0,0,0,0,0],onRange:0,menu:[]};
  var F = FORMULAS[CUR];
  (function overlayApprovedCopy(){
    var C = window.SPW_CONTENT || {};
    var VCAP_BY_FILE = C.__vcapByFile__ || null;
    Object.keys(FORMULAS).forEach(function(k){
      var c = C[k], f = FORMULAS[k];
      if(!c || !f) return;
      if(c.h1) f.h1 = c.h1;
      if(c.featureVideo){
        IMG["fv_" + k] = c.featureVideo.src;
        if(c.featureVideo.poster) IMG["fv_" + k + "_p"] = c.featureVideo.poster;
        f.featureVideo = { src: "fv_" + k,
          poster: c.featureVideo.poster ? "fv_" + k + "_p" : null,
          title: c.featureVideo.title, cap: c.featureVideo.cap,
          audio: false };
      }
      if(c.oneliner) f.oneliner = c.oneliner;
      if(c.specFill){ for(var sf in c.specFill){
        if(!f[sf]) f[sf] = c.specFill[sf]; } }
      if(c.bestLine) f.bestLine = c.bestLine;
      if(c.rv){
        if(c.rv.hist) f.hist = c.rv.hist.slice();
        if(c.rv.n) f.reviewCount = c.rv.n;
        if(c.rv.avg) f.rating = c.rv.avg;
      }
      if(c.subKey) f.subKey = c.subKey;
      if(c.dims && !f.dims) f.dims = c.dims;
      if(c.steps && c.steps.length && (!f.steps || !f.steps.length ||
          f.steps.every(function(s){ return /^Step \d+$/.test(s.h || ""); })))
        f.steps = c.steps;
      if(c.subNote) f.subNote = c.subNote;
      if(c.tabs && c.tabs.length) f.tabs = c.tabs;
      if(c.faqs && c.faqs.length && !(f.faqs && f.faqs.length))
        f.faqs = c.faqs;
      if(c.extraVideos && f.videos) c.extraVideos.forEach(function(x, xi){
        var xk = "xv_" + k + "_" + xi;
        if(IMG[xk]) return;
        IMG[xk] = x.src;
        f.videos.push({ src: xk, poster: null, handle: "", cap: "", audio: false });
      });
      if(VCAP_BY_FILE && f.videos) f.videos.forEach(function(v){
        var u = IMG[v.src] || "";
        var hit = VCAP_BY_FILE[u.split("/").pop().split("?")[0]];
        if(hit){ v.handle = hit.h; v.cap = hit.c; }
      });
      if(c.vcap && f.videos) f.videos.forEach(function(v, i){
        var cap = c.vcap[i];
        if(cap && !v.handle && !v.cap){ v.handle = cap.handle; v.cap = cap.cap; }
      });
      if(c.vlabel && f.variants) f.variants.forEach(function(v){
        var t = c.vlabel[v.t] || c.vlabel[String(v.t).split("/").pop().trim()];
        if(t) v.t = t;
      });
      /* Shopify returns hard wax as 2.2lb first and 1lb last. The artifact
         lists sizes smallest to largest, and the picker reads as a mistake
         otherwise. Stable, so families whose sizes all parse to 1 (warmers,
         accessories) keep the order Shopify gave them. */
      if(f.variants) f.variants = f.variants
        .map(function(v, i){ return [v, i]; })
        .sort(function(a, b){ return (a[0].lb - b[0].lb) || (a[1] - b[1]); })
        .map(function(p){ return p[0]; });
    });
  })();
  (function(){
    var map = DATA.formulas[CUR] && DATA.formulas[CUR].axisMap;
    if(!map) return;
    var cur = DATA.formulas[CUR], byFormula = {}, order = [];
    cur.variants.forEach(function(v){
      var name = v.opt1;
      if(!name) return;
      if(!byFormula[name]){ byFormula[name] = []; order.push(name); }
      byFormula[name].push(v);
    });
    cur.axis = order.map(function(name){
      var src = FORMULAS[map[name]] || {};
      var vs = byFormula[name].map(function(v){
        // the chip label is the Count, not "Blue / 20 Units"
        var o = {}; for(var k in v) o[k] = v[k];
        o.t = String(v.t).split(" / ").pop();
        return o;
      });
      // lead with this formula’s own variant images, then the rest of the
      // product gallery, so the hero changes with the chosen formula.
      var gal = [], seen = {};
      vs.concat([]).forEach(function(v){ if(v.img && !seen[v.img]){ seen[v.img]=1; gal.push(v.img); } });
      (cur.gal || []).forEach(function(g){ if(!seen[g]){ seen[g]=1; gal.push(g); } });
      // label from the OPTION value, not custom.formula: that metafield
      // reads "Green" on BOTH aloe-vera- and seaweed-roll-on-wax, so two
      // buttons came out identical. The option value is authoritative.
      return { key: map[name] || name, name: name,
               lane: src.lane || src.oneliner || "", oneliner: src.oneliner || "",
               hair: src.hair || cur.hair, best: src.best || cur.best,
               gal: gal, variants: vs };
    });
  })();

  var VARIANTS = F.variants, GAL = F.gal, STEPS = F.steps, REVIEWS = F.reviews;
  var THUMB = function(k){ return IMG[k + "_t"] || IMG[k]; };
  var galIdx = 0;
  // Default to the size closest to 5 lb that is actually buyable. Opening on the
  // 1 lb sample undersells the page; opening on a 30 lb column scares people off.
  // Only ever compare within a family. A soft wax can is not an alternative to a
  // roll-on cartridge, and the two families share formula names (Starsoft, Blue,
  // Natural, Creamy Pink), which made the old cross-family list read as duplicates.
  function famKeys(){
    return ORDER.filter(function(k){ return FORMULAS[k].family === F.family; });
  }

  function firstBuyable(){
    // Variant arrays are ordered smallest first. Open on the first buyable size,
    // and on the smallest when nothing is buyable. The hard wax build aimed at the
    // 5 lb pot, which is meaningless for a cartridge or a can and made an all
    // sold-out soft wax page open on the 6 can case price.
    for(var i = 0; i < VARIANTS.length; i++){ if(VARIANTS[i].avail) return i; }
    return 0;
  }

  var sel = firstBuyable();
  var didFirstRender = false;

  /* ---------- helpers ---------- */
  var $ = function(id){ return document.getElementById(id); };
  var money = function(n){ return "$" + Number(n || 0).toFixed(2); };
  var stars = function(n){ return "\u2605\u2605\u2605\u2605\u2605".slice(0, n) + "\u2606\u2606\u2606\u2606\u2606".slice(0, 5 - n); };

  /* ---------- images ---------- */

  function paintGallery(){
    $("galimg").src = IMG[GAL[galIdx]];
    $("galn").textContent = galIdx + 1;
    $("galtot").textContent = GAL.length;
    [].forEach.call(document.querySelectorAll("#thumbs button"), function(b, i){
      b.setAttribute("aria-current", i === galIdx ? "true" : "false");
    });
  }
  function buildThumbs(){
    var tw = $("thumbs");
    tw.innerHTML = "";
    GAL.forEach(function(k, i){
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", "View image " + (i + 1));
      var im = document.createElement("img");
      im.src = THUMB(k); im.alt = "";
      b.appendChild(im);
      b.addEventListener("click", function(){ galIdx = i; paintGallery(); });
      tw.appendChild(b);
    });
  }
  buildThumbs();
  $("prev").addEventListener("click", function(){ galIdx = (galIdx + GAL.length - 1) % GAL.length; paintGallery(); });
  $("next").addEventListener("click", function(){ galIdx = (galIdx + 1) % GAL.length; paintGallery(); });
  paintGallery();

  /* ---------- variants ---------- */
  // Both pickers are built from the same list and write to the same `sel`,
  // so the buy box and the sticky bar can never disagree.
  /* ---------- Formula axis (the consolidated product page only) ----------
     Product 14790346670443 is Formula x Count = 7 x 2. The seven single-formula
     entries in the prototype picker are that product with one formula chosen; this
     axis is the same product with ALL formulas on one page, which is how the real
     PDP is built. The size chips remain the Count axis. */
  var axisIdx = 0;
  function axisOn(){ return !!(F.axis && F.axis.length); }

  function buildAxis(){
    var wrap = $("faxisWrap");
    // Empty it, do not just hide it. Leaving the buttons in the DOM makes the
    // self-check count controls that are not on the page.
    if(!axisOn()){ wrap.hidden = true; $("faxis").innerHTML = ""; $("faxisSel").textContent = ""; return; }
    wrap.hidden = false;
    $("faxis").innerHTML = F.axis.map(function(a, i){
      var out = !a.variants.some(function(v){ return v.avail; });
      return '<button type="button" data-i="' + i + '" data-out="' + (out ? 1 : 0) + '"' +
             ' aria-pressed="' + (i === axisIdx ? "true" : "false") + '">' +
             '<span class="dot"></span>' + a.name + "</button>";
    }).join("");
    [].forEach.call($("faxis").children, function(b){
      b.addEventListener("click", function(){
        axisIdx = +b.getAttribute("data-i");
        applyAxis(true);
      });
    });
  }

  // Swap everything the Formula axis owns: the two Count variants, the gallery,
  // the specs that differ per formula, and the sub-headline.
  function applyAxis(repaint){
    if(!axisOn()) return;
    var a = F.axis[axisIdx];
    VARIANTS = a.variants;
    GAL = a.gal;
    sel = firstBuyable();
    galIdx = 0;
    $("faxisSel").textContent = a.lane;
    if(repaint){
      buildAxis();
      buildThumbs(); paintGallery();
      buildSizes(sizesEl); buildSizes(spopSizes, function(){ closeSizePop(); });
      paintAxisSpecs();
      render(); updateAll();
    }
  }

  // On the consolidated page hair type and best-for belong to the chosen formula,
  // not to the page, so they follow the axis.
  function paintAxisSpecs(){
    if(!axisOn()) return;
    var a = F.axis[axisIdx];
    var rows = document.querySelectorAll(".specs > div");
    [].forEach.call(rows, function(row){
      var dt = row.querySelector("dt"), dd = row.querySelector("dd");
      if(!dt || !dd) return;
      var label = dt.textContent.trim().toLowerCase();
      if(label === "hair type") dd.textContent = a.hair;
      else if(label === "best for") dd.textContent = a.best;
    });
  }

  function buildSizes(container, onPick){
    container.innerHTML = "";
    VARIANTS.forEach(function(v, i){
      var b = document.createElement("button");
      b.type = "button";
      b.className = "szbtn";
      b.setAttribute("aria-pressed", "false");
      if(!v.avail) b.setAttribute("data-out", "1");
      // A warmer is one unit, so a per-unit rate is noise. An accessory pack has a
      // real per-piece rate worth showing.
      var sub2;
      if(!v.avail)            sub2 = "Sold out";
      else if(v.lb > 1)       sub2 = money(v.price / v.lb) + " each";
      else                    sub2 = money(v.price);
      b.innerHTML = v.t + "<small>" + sub2 + "</small>";
      b.addEventListener("click", function(){ sel = i; render(); if(onPick) onPick(); });
      container.appendChild(b);
    });
  }
  var sizesEl = $("sizes"), spopSizes = $("spopsizes");
  buildSizes(sizesEl);
  buildSizes(spopSizes, function(){ closeSizePop(); });

  function render(){
    var v = VARIANTS[sel];
    var vidInput = document.getElementById("spwVariantId");
    if(vidInput && v.id) vidInput.value = v.id;
    var pro = v.pro != null ? v.pro : v.price * 0.8;

    $("pnow").textContent = money(v.price);
    var pw = $("pwas");
    // Five live soft wax variants carry a compare-at BELOW their price (the
    // single-can $26.90 was applied to multipacks), which would render as a price
    // rise. Suppress rather than display a wrong strikethrough.
    if(v.cmp && v.cmp > v.price){ pw.textContent = money(v.cmp); pw.hidden = false; }
    else { pw.hidden = true; }
    $("propill").textContent = "PRO PRICE " + money(pro) + " \u00b7 save 20%";

    // Cost per service is a wax idea. A warmer has no grams per service, so what a
    // pro actually weighs is capacity against bench space. For an accessory, a
    // per-unit rate wherever the pack size makes one meaningful.
    if(F.family === "warmer"){
      $("cpsMain").textContent = tidyRepeat(F.temp);
      $("cpsSub").textContent  = F.dims || "Dimensions not published for this model.";
      // no rationale note here: it is a build decision, not customer copy.
    } else {
      var per = v.lb > 1 ? v.price / v.lb : null;
      $("cpsMain").textContent = per ? money(per) + " each" : money(v.price);
      $("cpsSub").textContent  = per ? v.lb + " per pack, " + money(v.price) + " the pack"
                                     : "Single unit \u00b7 " + money(pro) + " at pro pricing";
    }


    // Match the gallery to the variant, the way the storefront does. Skipped on
    // the first paint so the page still opens on the product's featured image.
    if(didFirstRender && v.img){
      var gi = GAL.indexOf(v.img);
      if(gi >= 0 && gi !== galIdx){ galIdx = gi; paintGallery(); }
    }
    $("stickyimg").src = THUMB(v.img || GAL[0]);

    [ sizesEl, spopSizes ].forEach(function(box){
      [].forEach.call(box.children, function(b, i){
        b.setAttribute("aria-pressed", i === sel ? "true" : "false");
      });
    });

    var st = $("stockState");
    st.className = "state " + (!v.avail ? "out" : v.pre ? "pre" : "in");
    st.textContent = !v.avail ? "Sold out" : v.pre ? "Preorder \u00b7 out of stock" : "In stock \u00b7 ships today";

    // contextual notice, incl. the substitution path when a size is unavailable
    var n = $("notice");
    if(!v.avail){
      var alt = substituteFor(F);
      n.innerHTML = '<div class="notice out"><b>' + v.t + ' is sold out.</b> ' +
        'Get an alert the moment it is back' +
        (alt ? ', or reach for <a href="#compare" style="color:#8a2b56;font-weight:700">' + alt.name +
               '</a>, in stock now.'
             : (F.subNote ? '. ' + F.subNote : '.')) + '</div>';
    } else if(v.pre){
      n.innerHTML = '<div class="notice pre"><b>Out of stock, open for preorder.</b> ' +
        'Order now to hold your place in the next batch. Preorders are handled by Rez, ' +
        'which is why this stays buyable at zero stock.</div>';
    } else {
      n.innerHTML = "";
    }

    var atc = $("atc");
    if(v.avail){
      atc.className = "atc";
      atc.disabled = false;
      atc.textContent = (v.pre ? "Preorder " : "Add to cart ") + money(v.price);
    } else {
      atc.className = "atc notify";
      atc.disabled = false;
      atc.textContent = "Notify me when " + v.t + " is back";
    }
    syncNotify(v);


    // sticky bar mirrors the buy box, which is the bug that was live
    $("stickyprice").innerHTML = money(v.price) + (v.cmp && v.cmp > v.price ? " <s>" + money(v.cmp) + "</s>" : "");
    $("stickysizetext").textContent = v.t + (v.pre ? " \u00b7 preorder" : v.avail ? " \u00b7 in stock" : " \u00b7 sold out");
    var sb = $("stickyatc");
    sb.disabled = false;
    sb.textContent = v.avail ? (v.pre ? "Preorder" : "Add") : "Notify me";

    didFirstRender = true;
  }

  /* ---------- steps ---------- */
  var sn = $("stepnav");
  function buildSteps(){
    sn.innerHTML = "";
    STEPS.forEach(function(s, i){
      var b = document.createElement("button");
      b.type = "button";
      b.textContent = i + 1;
      b.setAttribute("aria-pressed", i === 0 ? "true" : "false");
      b.addEventListener("click", function(){ showStep(i); });
      sn.appendChild(b);
    });
  }
  buildSteps();
  function showStep(i){
    var s = STEPS[i];
    if(!s){
      var stepSec = sn && sn.closest ? sn.closest('section') : null;
      if(stepSec) stepSec.hidden = true;
      return;
    }
    $("stepnum").textContent = i + 1;
    $("steph").textContent = s.h;
    $("stepb").textContent = s.b;
    var t = $("steptip");
    if(s.tip){ t.textContent = s.tip; t.hidden = false; } else { t.hidden = true; }
    [].forEach.call(sn.children, function(b, j){ b.setAttribute("aria-pressed", i === j ? "true" : "false"); });
  }
  showStep(0);

  /* ---------- FAQ, built from the formula ---------- */
  function buildFaq(){
    if(!F.faqs || !F.faqs.length){
      var faqEl = $("faq"), faqSec = faqEl && faqEl.closest ? faqEl.closest('section') : null;
      if(faqSec) faqSec.hidden = true;
      return;
    }
    var faqShow = $("faq") && $("faq").closest ? $("faq").closest('section') : null;
    if(faqShow) faqShow.hidden = false;
    var box = $("faq");
    box.innerHTML = "";
    F.faqs.forEach(function(f){
      var item = document.createElement("div"); item.className = "acc-item";
      var btn = document.createElement("button");
      btn.className = "acc-btn"; btn.type = "button";
      btn.setAttribute("aria-expanded", "false");
      btn.innerHTML = f.q + ' <span class="chev">+</span>';
      var pan = document.createElement("div");
      pan.className = "acc-panel"; pan.hidden = true; pan.textContent = f.a;
      item.appendChild(btn); item.appendChild(pan); box.appendChild(item);
    });
  }
  buildFaq();

  /* ---------- reviews ---------- */
  // Roll-on reviews are one grouped Judge.me pool of 180 spanning every roll-on
  // product. Rebecca's rule: the page LOADS at range level and the formula filter
  // is opt-in. Moving the buy-box picker must NOT silently re-filter the reviews.
  var rvView = null;            // null = range level, else a formula key
  function rvSet(){
    if(F.family !== "rollon") return {hist:F.hist, list:F.reviews, n:sum5(F.hist), label:null};
    if(rvView){
      var m = rvMenu(rvView);
      return {hist:m.hist, list:m.reviews, n:m.n, label:m.name};
    }
    return {hist:RANGE.hist, list:F.reviews, n:RANGE.n, label:null};
  }
  function rvMenu(k){
    for(var i=0;i<RANGE.menu.length;i++){ if(RANGE.menu[i].key === k) return RANGE.menu[i]; }
    return null;
  }
  function sum5(h){ var t=0; for(var i=0;i<h.length;i++) t+=h[i]; return t; }

  function buildRvFilter(){
    var wrap = $("rvfilter");
    if(F.family !== "rollon"){ wrap.hidden = true; return; }
    wrap.hidden = false;
    var html = '<button type="button" data-k="" aria-pressed="' + (rvView ? "false" : "true") +
               '">Whole range<span class="n">(' + RANGE.n + ')</span></button>';
    html += RANGE.menu.map(function(m){
      return '<button type="button" data-k="' + m.key + '"' +
             (m.n === 0 ? " disabled" : "") +
             ' aria-pressed="' + (rvView === m.key ? "true" : "false") + '">' +
             m.name + '<span class="n">(' + m.n + ')</span></button>';
    }).join("");
    $("rvfchips").innerHTML = html;
    [].forEach.call($("rvfchips").children, function(b){
      b.addEventListener("click", function(){
        if(b.disabled) return;
        rvView = b.getAttribute("data-k") || null;
        buildRvFilter(); paintReviews($("sort").value); paintReviewHead();
      });
    });
    // The subsets sum to 178, not 180, because 2 reviews were written on the range
    // product itself. Say so rather than letting the numbers quietly not add up.
    $("rvfnote").textContent = rvView
      ? "Showing reviews written on " + rvMenu(rvView).name + " only. The whole-range view adds "
        + RANGE.onRange + " written on the range itself, which belong to no single formula."
      : "Every roll-on review, across all seven formulas. " + RANGE.onRange +
        " of these were written on the range itself and do not appear under any one formula.";
  }

  function paintReviews(mode){
    var r = rvSet().list.slice();
    if(mode === "recent") r.sort(function(a,b){ return a.date < b.date ? 1 : -1; });
    else if(mode === "high") r.sort(function(a,b){ return b.stars - a.stars; });
    else if(mode === "low") r.sort(function(a,b){ return a.stars - b.stars; });
    else r.sort(function(a,b){ return (b.verified?1:0) - (a.verified?1:0) || (a.date < b.date ? 1 : -1); });

    var RV_FIRST = 24;
    var shownAll = paintReviews.all === true;
    paintReviews.all = false;
    var slice = shownAll ? r : r.slice(0, RV_FIRST);
    var more = $("rvMore");
    if(!more){
      var lst = $("rvlist");
      if(lst && lst.parentNode){
        more = document.createElement("p");
        more.className = "rvmore"; more.id = "rvMore";
        lst.parentNode.insertBefore(more, lst.nextSibling);
      }
    }
    if(more){
      if(r.length > slice.length){
        more.innerHTML = '<button type="button" class="rvmore-btn">Show all ' + r.length + ' reviews</button>';
        more.firstChild.addEventListener("click", function(){
          paintReviews.all = true; paintReviews($("sort").value); });
      } else { more.innerHTML = ""; }
    }
    $("rvlist").innerHTML = slice.map(function(v){
      var d = new Date(v.date + "T00:00:00");
      var when = d.toLocaleDateString("en-US", { month:"short", day:"numeric", year:"numeric" });
      return '<article class="rv">' +
        '<div class="rv-top"><span class="st">' + stars(v.stars) + '</span>' +
        '<span class="who">' + v.who + '</span>' +
        (v.verified ? '<span class="ver">Verified buyer</span>' : '') +
        '<span class="when">' + when + '</span></div>' +
        '<h3 class="rv-t">' + (v.title || "") + '</h3><p>' + v.body + '</p></article>';
    }).join("");
  }
  function paintReviewHead(){
    // The headline and the histogram must always describe the SAME set as the list
    // beneath them, so both read from the active view rather than from F.
    var view   = rvSet();
    var counts = view.hist;
    var shown  = 0;
    for(var ci = 0; ci < counts.length; ci++){ shown += counts[ci]; }
    var avg = shown ? Math.round(counts.reduce(function(a,c,i){ return a + (i+1)*c; },0) / shown * 100) / 100 : 0;
    $("rvsummary").innerHTML =
      '<div class="rvbig">' + avg.toFixed(2) + '</div>' +
      '<div class="st" style="color:var(--pink-deep);letter-spacing:2px">' + stars(Math.round(avg)) + '</div>' +
      '<div style="font-size:12px;color:var(--mute);margin-top:4px">' + view.n + ' reviews' +
        (view.label ? ", " + view.label : (F.family === "rollon" ? ", whole range" : "")) + '</div>';
    var rows = "";
    for(var s = 5; s >= 1; s--){
      var pct = shown ? Math.round(counts[s-1] / shown * 100) : 0;
      if(counts[s-1] > 0 && pct < 2) pct = 2;   // a real review always shows a sliver
      rows += '<div class="rvrow"><span>' + s + '&#9733;</span><span class="rvtrack">' +
              '<span class="rvfill" style="width:' + pct + '%"></span></span><span>' + counts[s-1] + '</span></div>';
    }
    var _bars = $("rvbars");
    if(shown > 0){ _bars.innerHTML = rows; _bars.hidden = false; }
    else { _bars.innerHTML = ""; _bars.hidden = true; }
  }
  $("sort").addEventListener("change", function(e){ paintReviews(e.target.value); });
  /* ---------- Judge.me -> the Starpil review list ----------
     The widget below is the only source of individual reviews (Liquid gets
     the rating and the count, nothing more). Harvest what it rendered, paint
     it in our markup, then hide it. Hidden, not removed: Judge.me keeps
     running, and if this ever fails to find anything the widget is simply
     left visible, which is a working page rather than an empty one. */
  (function harvestJudgeme(){
    var mount = document.getElementById("judgeme_product_reviews");
    if(!mount) return;
    var done = false, curLen = 0;
    function esc(s){ return String(s).replace(/[&<>"]/g, function(c){
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
    function txt(n, sel){ var e = n.querySelector(sel); return e ? esc(e.textContent.trim()) : ""; }
    function parse(nodes){
      var out = [];
      Array.prototype.forEach.call(nodes, function(n){
        var rt = n.querySelector(".jdgm-rev__rating");
        var score = rt ? parseInt(rt.getAttribute("data-score"), 10) : 0;
        var tm = n.querySelector(".jdgm-rev__timestamp");
        var iso = tm ? String(tm.getAttribute("datetime") || "").slice(0, 10) : "";
        var who = txt(n, ".jdgm-rev__author") || "Verified buyer";
        var title = txt(n, ".jdgm-rev__title");
        var body = txt(n, ".jdgm-rev__body");
        var verified = n.getAttribute("data-verified-buyer") === "true";
        if(!title && !body) return;
        out.push({ stars: score, who: who, verified: verified,
                   date: iso, title: title, body: body });
      });
      return out;
    }
    function apply(out){ F.reviews = out; REVIEWS = out; paintReviews($("sort") ? $("sort").value : "helpful"); }
    /* Judge.me server-renders only page one (5 reviews) and pages the rest in
       through its own widget, which is hidden below. So read every page from
       the endpoint that widget uses and repaint with the full set. Fails quiet:
       on any error the first five stay up. */
    function loadAll(){
      var id = mount.getAttribute("data-id");
      var shop = (window.Shopify && Shopify.shop) || "";
      var pg = mount.querySelector(".jdgm-paginate");
      var api = (pg && pg.getAttribute("data-url")) || "https://api.judge.me/reviews/reviews_for_widget";
      if(!id || !shop || !window.fetch || !window.DOMParser) return;
      var all = [], total = Infinity;
      function page(p){
        var q = "url=" + encodeURIComponent(shop) + "&shop_domain=" + encodeURIComponent(shop) +
                "&platform=shopify&per_page=30&page=" + p + "&product_id=" + encodeURIComponent(id);
        return fetch(api + "?" + q)
          .then(function(r){ if(!r.ok) throw new Error("judgeme " + r.status); return r.json(); })
          .then(function(j){
            if(j.total_count != null) total = j.total_count;
            /* DOMParser, not innerHTML: an inert document, so review photos
               are not downloaded just to read the text. */
            var doc = new DOMParser().parseFromString(j.html || "", "text/html");
            var nodes = doc.querySelectorAll(".jdgm-rev");
            all = all.concat(parse(nodes));
            if(nodes.length && all.length < total && p < 40) return page(p + 1);
          });
      }
      page(1).then(function(){ if(all.length > curLen) apply(all); }).catch(function(){});
    }
    function harvest(){
      if(done) return true;
      var nodes = mount.querySelectorAll(".jdgm-rev");
      if(!nodes.length) return false;
      var out = parse(nodes);
      if(!out.length) return false;
      apply(out); curLen = out.length;
      var w = mount.querySelector(".jdgm-rev-widg") || mount;
      w.style.display = "none";
      done = true;
      loadAll();
      return true;
    }
    if(harvest()) return;
    /* Judge.me paints asynchronously, and re-paints on its own pagination. */
    var obs = new MutationObserver(function(){ if(harvest()) obs.disconnect(); });
    obs.observe(mount, { childList: true, subtree: true });
    setTimeout(function(){ obs.disconnect(); }, 20000);
  })();

  if(FORMULAS[CUR].axis){
    for(var ai0 = 0; ai0 < FORMULAS[CUR].axis.length; ai0++){
      if(FORMULAS[CUR].axis[ai0].variants.some(function(v){ return v.avail; })){ axisIdx = ai0; break; }
    }
    applyAxis(false);
  }
  buildAxis();
  buildRvFilter();
  paintReviews("helpful");
  paintReviewHead();

  /* ---------- cart + toast ---------- */
  var count = 0, toastTimer;
  function toast(msg){
    var t = $("toast");
    t.innerHTML = msg;
    t.setAttribute("data-show", "1");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.setAttribute("data-show", "0"); }, 3200);
  }
  /* ---------- Selleasy cross-sell ----------
     A mock of the live app widget so the prototype shows the page as a customer
     sees it. It appears only on the two warmers where the app actually renders it
     (verified live 10 Sep), and it is drawn with the override styling rather than
     the app default, which truncates every title and draws "Add" as plain text. */
  function paintCrossSell(){
    var sec = $("xsell"), cs = F.crossSell;
    if(!cs){ sec.hidden = true; $("xsList").innerHTML = ""; return; }
    sec.hidden = false;
    $("xsTitle").textContent = cs.label;
    $("xsOff").textContent   = cs.off;
    $("xsNote").textContent  = cs.note;
    $("xsList").innerHTML = cs.items.map(function(it, i){
      return '<div class="xs-row">' +
        '<img src="' + IMG[it.img] + '" alt="' + it.name + '">' +
        '<div class="xs-main">' +
          '<div class="xs-name">' + it.name + '</div>' +
          '<div class="xs-buy">' +
            '<span class="xs-price">' + money(it.price) +
              (it.cmp ? '<s>' + money(it.cmp) + '</s>' : '') + '</span>' +
            '<select aria-label="' + it.name + ' option">' +
              it.opts.map(function(o){ return '<option>' + o + '</option>'; }).join('') +
            '</select>' +
            '<button type="button" class="xs-add" data-i="' + i + '">Add</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join("");
    [].forEach.call($("xsList").querySelectorAll(".xs-add"), function(b){
      b.addEventListener("click", function(){
        var it = cs.items[+b.getAttribute("data-i")];
        count++; $("cartcount").textContent = count;
        b.textContent = "Added"; b.setAttribute("data-added", "1");
        setTimeout(function(){ b.textContent = "Add"; b.removeAttribute("data-added"); }, 1600);
        toast("<b>Added:</b> " + it.name + ", " + money(it.price) +
              " \u00b7 " + cs.off.toLowerCase());
      });
    });
  }

  /* Blockshop owns the cart drawer and the header count, so an add from this
     page should go through its API and behave like an add from anywhere else. */
  function themeCart(){
    var C = window.customElements && customElements.get("cart-element");
    return (C && typeof C.addItems === "function") ? C : null;
  }
  function refreshThemeCart(){
    var C = themeCart();
    if(!C || !C.updateTotals) return;
    var route = (window.Shopify && Shopify.routes ? Shopify.routes.cart : "/cart") + ".js";
    fetch(route).then(function(r){ return r.json(); })
      .then(function(c){ C.updateTotals(c.item_count); })
      .catch(function(){});
  }
  function addToCart(){
    var v = VARIANTS[sel];
    if(!v.avail){
      toast("<b>We'll email you</b> the moment " + v.t + " is back in stock.");
      return;
    }
    var body = spwForm ? new FormData(spwForm)
      : (function(){ var f = new FormData(); f.append("id", v.id); f.append("quantity", 1); return f; })();
    var C = themeCart();
    if(C){
      var secs = (C.sections || ["cart-drawer"]).join(",");
      C.addItems({
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(body).toString() + "&sections=" + secs
      }, $("atc")).then(function(){
        toast("<b>Added:</b> " + F.name + " " + v.t + ", " + money(v.price));
      }).catch(function(){
        toast("<b>Could not add to cart.</b> Please try again.");
      });
      return;
    }
    fetch("/cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: body })
      .then(function(r){ if(!r.ok) throw new Error("cart " + r.status); return r.json(); })
      .then(function(){
        toast("<b>Added:</b> " + F.name + " " + v.t + ", " + money(v.price));
        refreshThemeCart();
      })
      .catch(function(){ toast("<b>Could not add to cart.</b> Please try again."); });
  }
  var spwForm = document.getElementById("spw-product-form");
  if(spwForm){
    spwForm.addEventListener("submit", function(e){ e.preventDefault(); addToCart(); });
  } else {
    $("atc").addEventListener("click", addToCart);
  }
  $("stickyatc").addEventListener("click", function(){
    if(spwForm && spwForm.requestSubmit) spwForm.requestSubmit();
    else addToCart();
  });

  /* ---------- scroll-driven state: sticky bar + compact gallery ----------
     One passive listener, throttled to a frame. An IntersectionObserver is the
     usual advice here, but its failure mode is silent: an embedded viewer that
     delivers the first callback and then stops leaves the bar permanently
     hidden with nothing to detect. This costs one getBoundingClientRect read
     per frame while the finger is moving and nothing at all when it is not,
     and it behaves the same everywhere. The sticky gallery itself is pure CSS
     and needs no script. */
  var atcEl = $("atc"), stickyEl = $("sticky");
  var popEl;   // assigned by the size-picker block below; guarded until then

  /* ---------- desktop column balance ----------------------------------------
     .pdp-grid is align-items:start, so the short column simply stops and leaves
     a blank. Rather than hard-coding which blocks live where (the right amount
     differs a lot: 880px of blank on the 1lb warmer, 79px on a roll-on), pick
     the subset of movable blocks whose relocation brings the two columns
     closest in height. Two candidates means four subsets, so just try them
     all and take the best. Never runs on mobile: there the blocks stay in their
     authored order inside the buy column.

     Rebecca's call, 2026-09-10: only pure reading matter moves. Specs and the
     trust badges stay in the buy column where they were authored, because they
     are read while deciding. What comes down here instead is the warranty card
     (a long repair-or-replace paragraph nobody reads mid-purchase) and the
     "is this the right warmer for you" routing box.

     warrOffer is deliberately NOT a candidate. It is the 2-year protection
     opt-in, a checkbox that adds a cart line, so it has to stay next to Add to
     cart. Moving it would cost attach. */
  var CANDIDATES = ["warrBox", "swap"];   // also the order they stack in
  var homes = {};
  CANDIDATES.forEach(function(id){
    var e = $(id);
    if(e) homes[id] = { parent: e.parentNode, next: e.nextSibling };
  });
  function restoreBlocks(){
    CANDIDATES.forEach(function(id){
      var e = $(id), h = homes[id];
      if(e && h && e.parentNode !== h.parent) h.parent.insertBefore(e, h.next);
    });
  }
  function leftHeight(gal, side){
    if(!side.children.length) return gal.offsetHeight;
    return Math.round(side.getBoundingClientRect().bottom - gal.getBoundingClientRect().top);
  }
  function balanceColumns(){
    restoreBlocks();
    var side = $("sidecol"), buy = document.querySelector(".buycol"),
        gal = document.querySelector(".galcol");
    if(!side || !buy || !gal) return;
    if(document.body.getAttribute("data-view") === "mobile" || window.innerWidth < 901) return;

    var items = [];
    CANDIDATES.forEach(function(id){
      var e = $(id);
      if(e && !e.hidden && e.offsetParent !== null) items.push(e);
    });
    if(!items.length) return;

    /* Estimating the heights got two pages wrong, because a block does not keep
       the same height or margins once it moves. So actually apply each subset
       and measure it. This is all synchronous, so nothing paints in between and
       there is no flicker, and mask 0 is the untouched layout, which means the
       result can never be worse than leaving it alone. */
    var best = { diff: Math.abs(gal.offsetHeight - buy.offsetHeight), mask: 0 };
    for(var mask = 1; mask < (1 << items.length); mask++){
      restoreBlocks();
      for(var i = 0; i < items.length; i++){
        if(mask & (1 << i)) side.appendChild(items[i]);
      }
      var diff = Math.abs(leftHeight(gal, side) - buy.offsetHeight);
      if(diff < best.diff) best = { diff: diff, mask: mask };
    }
    restoreBlocks();
    for(var j = 0; j < items.length; j++){
      if(best.mask & (1 << j)) side.appendChild(items[j]);
    }
  }

  var balTimer = null;
  function scheduleBalance(){
    clearTimeout(balTimer);
    balTimer = setTimeout(balanceColumns, 60);
  }
  window.addEventListener("resize", scheduleBalance);

  function updateAll(){
    var show = atcEl.getBoundingClientRect().bottom < 0;
    stickyEl.setAttribute("data-show", show ? "1" : "0");
    if(!show && popEl && !popEl.hidden) closeSizePop();
  }
  function syncBar(){ updateAll(); }

  // Browsers already coalesce scroll to one event per frame, so calling straight
  // through is the same work as a rAF throttle without the latch that wedges if
  // a frame never arrives.
  window.addEventListener("scroll", updateAll, { passive: true });
  window.addEventListener("resize", updateAll);

  /* The gallery pins below the toolbar and the site header, so it needs the
     header's real height. A ResizeObserver on the header itself catches every
     cause of a change - viewport, device toggle, late font load - where a
     window resize listener misses several of them. */
  var hdrEl = document.querySelector("[data-section-type='header'], .site-header, header"),
      lastHdrH = 0, rsz;
  function setHdrH(h){
    h = Math.round(h);
    if(!h || h === lastHdrH) return;          // guard: no write, no relayout loop
    lastHdrH = h;
    document.documentElement.style.setProperty("--hdrh", h + "px");
    updateAll();
  }
  function measureChrome(){ if(hdrEl) setHdrH(hdrEl.offsetHeight); }
  measureChrome();
  window.addEventListener("load", measureChrome);   // logo decode can change it
  if(hdrEl && "ResizeObserver" in window){
    new ResizeObserver(function(entries){
      var e = entries[0];
      setHdrH(e.borderBoxSize && e.borderBoxSize.length
        ? e.borderBoxSize[0].blockSize
        : e.target.getBoundingClientRect().height);
      }).observe(hdrEl);
  } else {
    window.addEventListener("resize", function(){
      clearTimeout(rsz);
      rsz = setTimeout(measureChrome, 150);
    });
  }

  /* ---------- sticky bar size picker ----------
     Sits above the bar so someone reading the reviews can size up without
     scrolling back to the buy box. */
  popEl = $("stickypop");
  var sizeTrigger = $("stickysize");

  function openSizePop(){
    popEl.hidden = false;
    sizeTrigger.setAttribute("aria-expanded", "true");
  }
  function closeSizePop(){
    if(!popEl) return;
    popEl.hidden = true;
    sizeTrigger.setAttribute("aria-expanded", "false");
  }
  sizeTrigger.addEventListener("click", function(e){
    e.stopPropagation();
    if(popEl.hidden) openSizePop(); else closeSizePop();
  });
  $("spopclose").addEventListener("click", closeSizePop);
  popEl.addEventListener("click", function(e){ e.stopPropagation(); });
  document.addEventListener("click", function(){ if(!popEl.hidden) closeSizePop(); });
  document.addEventListener("keydown", function(e){ if(e.key === "Escape") closeSizePop(); });

  /* ---------- clamped intro on mobile ---------- */
  $("morebtn").addEventListener("click", function(){
    var el = $("oneliner"), open = el.getAttribute("data-open") === "1";
    el.setAttribute("data-open", open ? "0" : "1");
    this.textContent = open ? "More" : "Less";
  });

  /* ---------- formula comparison ----------
     Stock and price are read from one place so the table cannot drift from the
     store the way the hard-coded version did. An out-of-stock formula is kept
     but recessed and given a substitute: dropping the row entirely would leave
     the table with no answer to "what do I use for a full body service". */
  function cmpCell(v){
    if(v === null || v === undefined) return "\u2014";
    var s = String(v).trim();
    return (s === "" || s === "null" || s === "undefined") ? "\u2014" : s;
  }
  function specTrim(v){
    if(v === null || v === undefined) return v;
    var s = String(v).trim();
    s = s.replace(/^\s*(?:well\s+)?capacity\s*:\s*/i, "");
    s = s.replace(/^\s*power\s*:\s*/i, "");
    s = s.replace(/[\s,]*\b(?:adjustable\s+|dual\s+)*temperature\s+(?:dials?|range)\b\.?\s*$/i, "");
    s = s.replace(/\badjustable\s+temperature\s+/i, "");
    s = s.replace(/[\s,]*\bcapacity\b\.?\s*$/i, "");
    s = s.replace(/\s*\.\s*$/, "");
    return s.replace(/\s+/g, " ").trim();
  }
  function buildCompare(){
    // Rebecca 10 Sep: accessories get no comparison table at all, and the warmer
    // one is titled for warmers. "Which formula for which service" was wax copy
    // and described neither family, as did its Hair type / Working temp columns.
    var cmpSec = $("compare");
    if(F.family !== "warmer"){
      cmpSec.hidden = true; $("cmpBody").innerHTML = ""; $("cmpHead").innerHTML = ""; return;
    }
    cmpSec.hidden = false;
    $("cmpTitle").textContent = "Which warmer is right for me";
    $("cmpSub").textContent   = "Capacity, heat and price side by side.";
    $("cmpHead").innerHTML =
      "<th>Warmer</th><th>Capacity</th><th>Heats to</th><th>Power</th><th>From</th>";

    $("cmpBody").innerHTML = famKeys().map(function(k){
      var f = FORMULAS[k];
      var out = !f.variants.some(function(v){ return v.avail; });
      var here = f.key === CUR;
      var badge = here ? '<span class="badge here">You\u2019re here</span>'
                : out  ? '<span class="badge oos">Sold out</span>' : "";
      var sub = "";
      if(out){
        var alt = substituteFor(f);
        if(alt) sub = '<span class="sub-note">Out right now, reach for ' + alt.name + '</span>';
      }
      var from = Math.min.apply(null, f.variants.map(function(v){ return v.price; }));
      // The substitute note belongs with the name, not buried in a spec cell.
      return '<tr class="' + (here ? "self" : "") + (out ? " isout" : "") + '">' +
        '<td class="pname">' + f.name + badge + sub +
          (f.bestLine ? '<span class="sub-note bestfor">' + f.bestLine + '</span>' : "") +
        '</td>' +
        '<td>' + cmpCell(specTrim(f.temp)) + (f.qual ? '<span class="qual">' + cmpCell(f.qual) + '</span>' : "") + '</td>' +
        '<td>' + cmpCell(specTrim(f.hair)) + '</td>' +
        '<td>' + cmpCell(specTrim(f.zone)) + '</td>' +
        '<td>' + money(from) + '</td></tr>';
    }).join("");
  }
  buildCompare();

  /* ---------- feature video ----------
     Rebecca 10 Sep: the UGC reel comes out for hardware, and a warmer with no
     footage skips the section entirely. Only 5 of 23 entries have a clip, so this
     is absent far more often than present. One <video> presented as a feature: no
     rail, no dots, no wrap-around index maths, no PLAYING chrome, no sound toggle.
     "Wax made to go viral" was a UGC framing and does not carry over. */
  function featOn(){ return !!F.featureVideo; }

  function paintFeature(){
    var band = $("featband"), v = $("featvid");
    if(!featOn()){
      band.hidden = true;
      v.pause(); v.removeAttribute("src"); v.removeAttribute("poster"); v.load();
      return;
    }
    var fv = F.featureVideo;
    band.hidden = false;
    v.pause();
    v.src = IMG[fv.src];
    if(IMG[fv.poster]) v.poster = IMG[fv.poster];
    v.muted = !fv.audio;
    v.load();
    $("feattitle").textContent = fv.title;
    $("featcap").textContent = fv.cap;
  }
  paintFeature();

  /* ---------- "how it works" tabs ---------- */
  var TABS = F.tabs;
  var tabsEl = $("tabs"), tabPanel = $("tabpanel");

  function buildTabs(){
    tabsEl.innerHTML = "";
    TABS.forEach(function(t, i){
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("role", "tab");
      b.innerHTML = t.k;
      b.setAttribute("aria-selected", i === 0 ? "true" : "false");
      b.addEventListener("click", function(){ showTab(i); });
      tabsEl.appendChild(b);
    });
  }
  buildTabs();
  function showTab(i){
    var t = TABS[i];
    if(!t) return;   // prose is rendered by Liquid; nothing to paint
    tabPanel.innerHTML = "<div>" + t.b + "</div>" +
      (t.why ? "<div class='tabwhy'>" + t.why + "</div>" : "");
    [].forEach.call(tabsEl.children, function(b, j){
      b.setAttribute("aria-selected", i === j ? "true" : "false");
    });
    // On a narrow phone the strip scrolls; keep the chosen tab in view.
    var sel = tabsEl.children[i];
    if(sel && tabsEl.scrollWidth > tabsEl.clientWidth + 1){
      var l = sel.offsetLeft, r = l + sel.offsetWidth;
      if(l < tabsEl.scrollLeft) tabsEl.scrollLeft = Math.max(0, l - 12);
      else if(r > tabsEl.scrollLeft + tabsEl.clientWidth)
        tabsEl.scrollLeft = r - tabsEl.clientWidth + 12;
    }
  }
  showTab(0);


  /* ---------- substitute routing ----------
     Each formula names the one that covers its work (Blue -> Malva, not Pink,
     because Pink cracks on legs). Falls back to any in-stock formula only if
     the named substitute is itself out. */
  function substituteFor(f){
    // Only ever the NAMED substitute, and only if it is in stock and in the same
    // family. The old "first in stock in ORDER" fallback is what sent full-body
    // buyers to a zone wax on the hard wax build; here it would send a sensitive
    // skin buyer to a formula that does not own that lane, or a soft wax buyer to
    // a roll-on cartridge. No safe substitute means no substitute.
    var inStock = function(c){ return c.variants.some(function(v){ return v.avail; }); };
    var named = f.subKey && FORMULAS[f.subKey];
    if(named && named.family === f.family && inStock(named)) return named;
    return null;
  }

  /* ---------- copy that changes with the formula ---------- */
  function paintCopy(){
    $("h1").textContent = F.h1;
    $("crumb").textContent = F.full;
    // The sticky bar title was hardcoded to "Pink Hard Wax Beads" from the hard wax
    // build and never repainted, so it was wrong on all 23 pages.
    // The short name, not the full one. A 390px bar cannot hold "Premium
    // Extra-Large Hard Wax Warmer 10lb", and the full name is in the H1 anyway.
    $("stickytitle").textContent = F.name;
    $("galimg").alt = F.full;
    $("oneliner").textContent = F.oneliner;
    $("ratingVal").textContent = F.rating.toFixed(2);
    $("ratingStars").innerHTML = stars(Math.round(F.rating));
    $("ratingCount").textContent = F.reviewCount + " reviews";
    var dq = $("rodisc");
    if(F.disclaimer){ dq.textContent = F.disclaimer; dq.hidden = false; } else { dq.hidden = true; }
    // The wax specs grid does not describe hardware. A warmer is chosen on
    // capacity, heat and warranty; an accessory on material, size and what it fits.
    var W = F.family === "warmer";
    var L1 = W ? "Capacity" : "Material";
    var L2 = W ? "Heats to" : "Size";
    var L3 = W ? "Power"    : "Use with";
    var L4 = W ? "Warranty" : "Count";
    $("specs").innerHTML = [[L1, F.temp], [L2, F.hair], [L3, F.zone]]
      .filter(function(c){ return c[1] != null && String(c[1]).trim() !== ""; })
      .map(function(c){ return '<div data-spec="' + String(c[0]).toLowerCase().replace(/[^a-z0-9]+/g, "-") + '">' + "<dt>" + c[0] + "</dt><dd>" + c[1] + "</dd></div>"; })
      .join("");

    // The one-year warranty was buried at the end of a tab. It is a real reason to
    // buy, and it is NOT the same promise across the range, so it gets its own
    // element and each product shows its own wording.
    var wb = $("warrBox");
    if(F.warranty){
      wb.hidden = false;
      $("warrShort").textContent = F.spec4;
      $("warrText").textContent  = F.warranty;
    } else { wb.hidden = true; }

    // Accessories have no how-to steps. Remove the section rather than render it empty.
    $("howtosec").hidden = !(F.steps && F.steps.length);
    $("love").innerHTML = F.love.map(function(x){ return "<li>" + x + "</li>"; }).join("");
    $("loveSub").textContent = "Where " + F.name + " sits in the line.";
    var others = famKeys().filter(function(k){ return k !== CUR; })
                          .map(function(k){ return FORMULAS[k].name; });
    var extra = F.extra ? '<div style="margin-top:8px"><a href="' + F.extra.url +
                          '" target="_blank" rel="noopener">' + F.extra.label + ' &#8594;</a></div>' : "";
    $("swap").innerHTML = (axisOn()
        ? "<b>Not sure which formula is right for your services?</b> Compare "
        : "<b>Not sure " + F.name + " is right for your services?</b> Compare it against ") +
      swapList(others, F.family === "warmer" ? "every other warmer we make"
        : F.family === "accessory" ? "the rest of the accessories"
        : "the rest of the range") +
      (F.family === "warmer" ? ' <a href="#compare">See the comparison &#8594;</a>' : "") + extra;
    $("crumbFam").textContent = F.family === "warmer" ? "Warmers" : "Accessories";
  }

  /* ---------- formula switching ---------- */
  function mountFormula(key){
    CUR = key;
    F = FORMULAS[key];
    VARIANTS = F.variants; GAL = F.gal; STEPS = F.steps; REVIEWS = F.reviews;
    TABS = F.tabs;
    // Open the consolidated page on the first formula that is actually buyable,
    // so the page does not load on a sold-out variant when stock exists.
    if(F.axis && F.axis.length){
      axisIdx = 0;
      for(var ai = 0; ai < F.axis.length; ai++){
        if(F.axis[ai].variants.some(function(v){ return v.avail; })){ axisIdx = ai; break; }
      }
      applyAxis(false);
    }
    sel = firstBuyable(); galIdx = 0; didFirstRender = false;

    paintCopy();
    buildAxis();
    buildThumbs(); paintGallery();
    buildSizes(sizesEl); buildSizes(spopSizes, function(){ closeSizePop(); });
    if(STEPS.length){ buildSteps(); showStep(0); } else { $("stepnav").innerHTML = ""; }
    buildTabs(); showTab(0);
    buildFaq(); buildCompare();
    // Rebecca's rule: moving the buy-box picker must NOT touch the review filter,
    // it "leaves the review block where the user put it". So rvView survives a
    // roll-on to roll-on switch. It is only cleared when we leave the roll-on
    // family, because the grouped pool does not exist for soft wax.
    if(F.family !== "rollon") rvView = null;
    buildRvFilter();
    scheduleBalance();
    paintFeature(); paintReviews($("sort").value); paintReviewHead();
    render(); updateAll();
  }

  // The two families share four formula names (Blue, Creamy Pink, Natural,
  // Starsoft), so a flat list of f.name renders visible duplicates with no way to
  // tell a roll-on cartridge from a soft wax can. Group them and say which
  // product each group is.

  /* Only one back-in-stock button. Rez owns that job; ours is the fallback. */
  function syncNotify(v){
    if(v) syncNotify.v = v;
    v = syncNotify.v;
    var atc = $("atc");
    if(!atc) return;
    var rez = document.querySelector(".spw-form .rez-stock-notification-button");
    atc.hidden = !!(v && !v.avail && rez);
  }
  function syncUpsell(){
    var off = (window.SPW_CONTENT || {}).__noUpsell__ || [];
    if(off.indexOf(CUR) === -1) return;
    var el = document.querySelector("lb-upsell-product-page-addon");
    if(el) el.hidden = true;
  }
  syncUpsell();
  (function watchRez(){
    var form = document.querySelector(".spw-form");
    if(!form || !window.MutationObserver) return;
    var obs = new MutationObserver(function(){ syncNotify(); syncUpsell(); });
    obs.observe(form, { childList: true, subtree: true });
    setTimeout(function(){ obs.disconnect(); }, 20000);
  })();


  /* A list of names only helps while you can scan it. Past that, name the range. */
  function swapList(names, phrase){
    if(!names || !names.length) return phrase + ".";
    var joined = names.length > 1
      ? names.slice(0, -1).join(", ") + " and " + names[names.length - 1]
      : names[0];
    return (names.length <= 6 && joined.length <= 72) ? joined + "." : phrase + ".";
  }


  /* Drops a word the string already used, so a label and its value stop echoing. */
  function tidyRepeat(s){
    if(!s) return s;
    return String(s)
      .replace(/\b(capacity)\b([\s\S]*?)\bcapacity\b/i, "$1$2")
      .replace(/\s{2,}/g, " ")
      .replace(/\s+([.,])/g, "$1")
      .trim();
  }

  mountFormula(CUR);
})();
